import { Link } from 'react-router-dom';
import { FileSearch, ArrowLeft } from 'lucide-react';

export default function ApisPage() {
  return (
    <div className="p-8">
      <Link to="/verify" className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-slate-700 dark:hover:text-slate-300 transition-colors mb-4">
        <ArrowLeft className="w-4 h-4" /> Back to Verify
      </Link>

      <div className="mb-6">
        <h1 className="text-2xl font-bold text-slate-900 dark:text-slate-100">API Contracts</h1>
        <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">
          Browse OpenAPI specs and detect drift between deployed APIs and repository definitions.
        </p>
      </div>

      <div className="rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-8 text-center">
        <FileSearch className="mx-auto h-10 w-10 text-slate-300 dark:text-slate-700" />
        <h2 className="mt-4 font-semibold text-slate-900 dark:text-slate-100">Coming soon</h2>
        <p className="mt-2 text-sm text-slate-500 max-w-md mx-auto">
          API contract viewing and drift detection will be available once OpenAPI specs are auto-discovered from connected repositories.
        </p>
      </div>
    </div>
  );
}
